<template>
  <div
    class="mr-auto"
    :class="vertical ? 'flex-wrap' : 'd-flex'"
  >
    <b-form-select
      v-model="selectedCategory"
      :class="vertical ? 'mb-3' : 'mr-3'"
      @change="setCategory"
    >
      <template v-slot:first>
        <b-form-select-option :value="undefined">
          -- {{ $t('product.categories.single') }} --
        </b-form-select-option>
      </template>
      <b-form-select-option
        v-for="category in categories"
        :key="category.id"
        :value="category.id"
      >
        {{ $l(category.title) }}
      </b-form-select-option>
    </b-form-select>
    <b-form-select
      v-model="selectedSub"
      :class="vertical ? 'mb-3' : 'mr-3'"
      @change="setSubcategory"
    >
      <template v-slot:first>
        <b-form-select-option :value="undefined">
          -- {{ $t('product.subcategory') }} --
        </b-form-select-option>
      </template>
      <b-form-select-option
        v-for="sub in subCategories"
        :key="sub.id"
        :value="sub.id"
      >
        {{ $l(sub.title) }}
      </b-form-select-option>
    </b-form-select>
    <b-form-select
      v-model="selectedSection"
      :class="vertical ? 'mb-3' : 'mr-3'"
      @change="setSection"
    >
      <template v-slot:first>
        <b-form-select-option :value="undefined">
          -- {{ $t('product.section') }} --
        </b-form-select-option>
      </template>
      <b-form-select-option
        v-for="section in sections"
        :key="section.id"
        :value="section.id"
      >
        {{ $l(section.title) }}
      </b-form-select-option>
    </b-form-select>
  </div>
</template>

<script>
import categoryService from '@/services/api/admin/library/categories-service'
import productService from '@/services/api/manager/product-service'
import { mapGetters } from 'vuex'

export default {
  name: 'SingleSectionSelector',
  props: {
    vertical: {
      type: Boolean,
      default() {
        return false
      },
    },
    initialCat: {
      type: Number,
      default() {
        return undefined
      },
    },
    initialSub: {
      type: Number,
      default() {
        return undefined
      },
    },
    initialSec: {
      type: Number,
      default() {
        return undefined
      },
    },

    permittedSections: {
      type: Array,
      default: () => null,
    },
  },

  data() {
    return {
      selectedCategory: null,
      selectedSub: null,
      selectedSection: null,
      mappedCategories: {},
    }
  },

  computed: {
    categories() {
      return Object.values(this.mappedCategories)
    },
    subCategories() {
      if (this.selectedCategory != null && this.mappedCategories[this.selectedCategory])
        return Object.values(this.mappedCategories[this.selectedCategory].subCategories)
      else return []
    },
    sections() {
      if (this.selectedSub && this.mappedCategories[this.selectedCategory] && this.mappedCategories[this.selectedCategory].subCategories[this.selectedSub])
        return Object.values(this.mappedCategories[this.selectedCategory].subCategories[this.selectedSub].sections)
      else return []
    },
    ...mapGetters({
      role: 'user/role',
    }),
  },

  async mounted() {
    let data
    if (this.role === 'ADMIN') {
      const response = await categoryService.categoriesList()
      data = response.data
    } else {
      const response = await productService.getSellerCategories()
      data = response.data
    }
    this.mappedCategories = this.mapCategories(data.content)

    this.selectedCategory = this.initialCat
    this.selectedSub = this.initialSub
    this.selectedSection = this.initialSec
  },
  methods: {
    setCategory() {
      this.selectedSection = undefined
      this.selectedSub = undefined
      this.emitValues()
    },
    setSubcategory() {
      this.selectedSection = undefined
      this.emitValues()
    },
    setSection() {
      this.emitValues()
    },
    emitValues() {
      let category = null; let sub = null; let section = null

      const categories = this.mappedCategories

      if (this.selectedCategory || this.selectedCategory === 0) {
        category = categories[this.selectedCategory]
      }
      if (category != null && (this.selectedSub || this.selectedSub === 0)) {
        sub = categories[this.selectedCategory].subCategories[this.selectedSub]
      }
      if (sub != null && (this.selectedSection || this.selectedSection === 0)) {
        section = sub.sections[this.selectedSection]
      }

      this.$emit('selected', category?.id, sub?.id, section?.id)
    },
    mapCategories(categories) {
      const mapped = {}
      categories.forEach(cat => {
        cat.subCategories = this.mapSubcategories(cat.sub_categories)
        if (Object.keys(cat.subCategories).length > 0) {
          mapped[cat.id] = cat
        }
      })

      return mapped
    },
    mapSubcategories(subcategories) {
      const mapped = {}

      subcategories.forEach(subCat => {
        subCat.sections = this.mapSections(subCat.sections)
        if (Object.keys(subCat.sections).length > 0) {
          mapped[subCat.id] = subCat
        }
      })

      return mapped
    },
    mapSections(sections) {
      const mapped = {}

      sections.forEach(section => {
        if (this.permittedSections === null || this.permittedSections.includes(section.id)) {
          mapped[section.id] = section
        }
      })

      return mapped
    },
  },
}
</script>

<style scoped>

</style>
